<mat-accordion multi class="expand-collapse-panel">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
    </mat-expansion-panel-header>
    <form autocomplete="off" [formGroup]="form" id="filterFacilityManager" class="filter-form">
      <div class="filter-field">
        <mat-form-field class="search-input">
          <mat-label>Contract Number</mat-label>
          <input placeholder="Contract Number"
            matInput
            [matChipInputFor]="chipContractNumber"
            [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
            [matChipInputAddOnBlur]="addOnBlur"
            (matChipInputTokenEnd)="applyFilter($event, 'contractnumbers')">
          </mat-form-field>
          <mat-chip-grid #chipContractNumber>
            @for (item of contractNumbers; track item) {
              <mat-chip-row
                [removable]="removable" (removed)="remove(item, 'contractnumbers')">
                {{item}}
                @if (removable) {
                  <mat-icon matChipRemove>cancel</mat-icon>
                }
              </mat-chip-row>
            }
          </mat-chip-grid>
        </div>
        <div class="filter-field">
          <mat-form-field class="search-input">
            <mat-label>Facilities Manager Id</mat-label>
            <input placeholder="Facilities Manager Id"
              matInput
              [matChipInputFor]="chipFacilityManagerIds"
              [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
              [matChipInputAddOnBlur]="addOnBlur"
              (matChipInputTokenEnd)="applyFilter($event, 'facilitymanagerids')">
            </mat-form-field>
            <mat-chip-grid #chipFacilityManagerIds>
              @for (item of facilityManagerIds; track item) {
                <mat-chip-row
                  [removable]="removable" (removed)="remove(item, 'facilitymanagerids')">
                  {{item}}
                  @if (removable) {
                    <mat-icon matChipRemove>cancel</mat-icon>
                  }
                </mat-chip-row>
              }
            </mat-chip-grid>
          </div>
          <div class="filter-actions">
            <button type="button" class="btn mat-flat-button btn-primary" (click)="onFilter()">
              {{ changeTypeButton() ? 'Reset' : 'Filter' }}
            </button>
          </div>
        </form>
      </mat-expansion-panel>
    </mat-accordion>